import { render, staticRenderFns } from "./MainFooterBanner.vue?vue&type=template&id=03a2cf8a"
import script from "./MainFooterBanner.vue?vue&type=script&lang=js"
export * from "./MainFooterBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports